type Props<T> = {
  fn: () => Promise<T>;
  delayMs: number;
};

export function delayedFunction<T>({
  fn,
  delayMs,
}: Props<T>): () => Promise<T> {
  return () =>
    new Promise((resolve, reject) => {
      setTimeout(async () => {
        try {
          const response = await fn();
          resolve(response);
        } catch (error) {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject(error as Error);
        }
      }, delayMs);
    });
}
